module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainTableContainer"
  }, [_c('div', {
    staticClass: "table-nav"
  }, [_c('el-link', [_vm._v("xx 公司")]), _vm._v(" "), _c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("主表")]), _vm._v(" "), _c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("附表一")]), _vm._v(" "), _c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("附表二")]), _vm._v(" "), _c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("附表三")]), _vm._v(" "), _c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("附表四")])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "tb-edit",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mainTable,
      "span-method": _vm.objectSpanMethod,
      "border": "",
      "highlight-current-row": "",
      "row-class-name": _vm.rowClass
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "增 值 税 纳 税 申 报 表",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label-class-name": "font12",
      "label": "（一般纳税人适用）",
      "header-align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "left",
      "label-class-name": "font10 color999",
      "label": "    根据国家税收法律法规及增值税相关规定制定本表。纳税人不论有无销售额，均应按税务机关核定的纳税期限填写本表，并向当地税务机关申报。"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "项     目",
      "header-align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "40px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "width": "14px",
            "font-size": "14px",
            "word-wrap": "break-word",
            "letter-spacing": "20px"
          }
        }, [_vm._v(_vm._s(scope.row.itemType))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.titles && scope.row.titles.length > 0) ? _c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "right"
          }
        }, [_c('div', _vm._l((scope.row.titles), function(title) {
          return _c('p', {
            key: title
          }, [_vm._v(_vm._s(title))])
        }), 0), _vm._v(" "), _c('div', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('el-badge', {
          staticClass: "hasTitle",
          attrs: {
            "is-dot": ""
          }
        }, [_vm._v(_vm._s(scope.row.item))])], 1)]) : _c('div', {
          staticStyle: {
            "white-space": "pre"
          }
        }, [_vm._v(_vm._s(scope.row.item))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "栏次",
      "header-align": "center",
      "prop": "lc"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "一般项目",
      "header-align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "本月数",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "disabled": _vm.isDisable(scope.row),
            "change": _vm.inputChange(scope.row, scope.row.a1),
            "placeholder": "请输入一般项目本月数"
          },
          model: {
            value: (scope.row.a1),
            callback: function($$v) {
              _vm.$set(scope.row, "a1", $$v)
            },
            expression: "scope.row.a1"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.a1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "本年累计",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "disabled": _vm.isDisable(scope.row),
            "change": _vm.inputChange(scope.row, scope.row.a1),
            "placeholder": "请输入一般项目本年累计"
          },
          model: {
            value: (scope.row.a2),
            callback: function($$v) {
              _vm.$set(scope.row, "a2", $$v)
            },
            expression: "scope.row.a2"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.a2))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "即征即退项目",
      "header-align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "本月数",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "disabled": _vm.isDisable(scope.row),
            "change": _vm.inputChange(scope.row, scope.row.a1),
            "placeholder": "请输入即征即退项目本月数"
          },
          model: {
            value: (scope.row.b1),
            callback: function($$v) {
              _vm.$set(scope.row, "b1", $$v)
            },
            expression: "scope.row.b1"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.b1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "本年累计",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "small",
            "disabled": _vm.isDisable(scope.row),
            "change": _vm.inputChange(scope.row, scope.row.a1),
            "placeholder": "请输入即征即退项目本年累计"
          },
          model: {
            value: (scope.row.b2),
            callback: function($$v) {
              _vm.$set(scope.row, "b2", $$v)
            },
            expression: "scope.row.b2"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.b2))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "can-space"
  }, [_vm._v("主管税务机关： 接收人：")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7734f5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nssb/mainTable.vue
// module id = 726
// module chunks = 1